import { DurationDisplay } from 'utils/date';
import { ITimeRangeSliderOption } from './types';
import dayjs from 'dayjs';

const range = (startValue: number, endValue: number) => {
	return Array.apply(0, Array(endValue - startValue)).map((_, index) => index + startValue);
};

export const TIME_RANGE_MARKS_S = [
	...range(1, 24).map((el) => dayjs.duration(el, 'hours').asSeconds()),
	...range(1, 31).map((el) => dayjs.duration(el, 'days').asSeconds()),
];

export const NEW_TIME_RANGE_MARKS: Record<number, ITimeRangeSliderOption> = TIME_RANGE_MARKS_S.map(
	(seconds, index) => ({
		key: index,
		label: <DurationDisplay duration={dayjs.duration(seconds, 'seconds')} />,
		value: seconds,
	})
);

export const NEW_TIME_RANGE_MARKS_LENGTH = Object.entries(NEW_TIME_RANGE_MARKS).length - 1;
